import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { buildOidcConfig } from './auth.js';
import { loadRuntimeConfig, type RuntimeConfig } from './config.js';
import { ApiClient } from './api.js';
import { ConfigContext } from './context.js';
import './styles.css';

async function bootstrap(): Promise<void> {
  const config: RuntimeConfig = await loadRuntimeConfig();
  const oidcConfig = buildOidcConfig(config);

  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <ConfigContext.Provider value={config}>
          <BrowserRouter>
            <App apiFactory={(getToken) => new ApiClient(config.apiBaseUrl, getToken)} />
          </BrowserRouter>
        </ConfigContext.Provider>
      </AuthProvider>
    </React.StrictMode>,
  );
}

void bootstrap().catch((err) => {
  const root = document.getElementById('root');
  if (root) {
    root.textContent = `Failed to start: ${err instanceof Error ? err.message : String(err)}`;
  }
});
